if (typeof localizationForm === 'undefined') {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };

      
      if (!this.elements.input) return;

      
      this.querySelectorAll('a[data-value], button[data-value]').forEach((item) =>
        item.addEventListener('click', this.onItemClick.bind(this))
      );

      
    }

    onItemClick(event) {
      event.preventDefault();

      
      const value =
        event.currentTarget?.dataset?.value || event.currentTarget?.getAttribute('data-value');
      if (!value) return;

      
      const input =
        this.elements?.input ||
        this.querySelector('input[name="locale_code"]') ||
        this.querySelector('input[name="country_code"]');

      if (!input) return;

      input.value = value;

     
      const form = this.querySelector('form');
      if (form) form.submit();
    }

    openSelector() {
      if (!this.elements.button || !this.elements.panel) return;

      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      if (!this.elements.button || !this.elements.panel) return;

      const shouldClose = event?.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event?.relatedTarget === null || shouldClose) {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }
    }

    onBodyClickEvent(event) {
      if (!event) return;

      
      if (!this.contains(event.target) && !event.target.closest('[localization-form__select]')) {
        this.closeSelector(event);
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  var localizationForm = LocalizationForm;
}
